import { useState, type FormEvent } from 'react';
import { useLogin } from '../hooks/useAuth';
import { Logo } from '../components/Logo';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const login = useLogin();

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    login.mutate({ email, password });
  }

  const errMsg = login.error
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ((login.error as any)?.response?.data?.error?.message ?? 'Accesso non riuscito')
    : null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper px-4">
      <div className="w-full max-w-md">
        {/* Brand: icona + nome IXAM sulla stessa riga, payoff sotto della stessa larghezza */}
        <div className="mb-8 flex flex-col items-center">
          <div className="inline-flex items-center gap-3">
            <Logo size={56} variant="mark" />
            <div className="font-extrabold text-4xl text-ink tracking-tight leading-none">
              IXAM
            </div>
          </div>
          <div className="mt-2.5 text-sm font-medium text-ink-muted">
            Monitor alert hardware
          </div>
        </div>

        <div className="ixam-card p-8">
          <h1 className="font-bold text-xl mb-1">Accedi</h1>
          <p className="text-sm text-ink-muted mb-6">
            Inserisci le tue credenziali per continuare.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-ink mb-1.5">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                className="ixam-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-ink mb-1.5">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                className="ixam-input"
              />
            </div>
            {errMsg && (
              <div className="px-3 py-2.5 bg-sev-critical-soft border border-sev-critical/30 rounded-lg text-sm text-sev-critical">
                {errMsg}
              </div>
            )}
            <button
              type="submit"
              disabled={login.isPending}
              className="ixam-btn w-full justify-center py-2.5"
            >
              {login.isPending ? 'Accesso in corso…' : 'Entra'}
            </button>
          </form>
        </div>

        <p className="text-center text-xs text-ink-faint mt-6">Tribus Informatica Srl</p>
      </div>
    </div>
  );
}
